/**
 * Follows a presigned download URL. It is a navigation, not a fetch: the browser writes the document straight to disk
 * rather than the page holding up to 100 MB of it first, and the response carries `Content-Disposition: attachment`, so
 * the browser saves the file and the page stays put. Only a Word document's preview is fetched, which is what the
 * storage bucket's CORS rule and its place in the Content-Security-Policy's `connect-src` are for.
 *
 * It is its own module so tests can replace it; jsdom cannot navigate.
 */
export function openDownload(url: string): void {
	const anchor = document.createElement("a");
	anchor.href = url;
	anchor.rel = "noopener";
	document.body.append(anchor);
	anchor.click();
	anchor.remove();
}
